import { PartnerDetailType } from "../../../../../redux/slices/partner-details/Types";

/** Fixed columns shown in the Columns dropdown (in display order). */
export const PARTNER_COLUMN_ALLOWLIST = [
  "partner_name",
  "partner_type",
  "region",
  "partner_tier",
  "support_level",
  "status",
  "account_manager",
  "partner_email",
  "website",
  "country",
  "revenue_stream",
  "partner_potential",
  "partner_vertical",
  "registration_date",
  "last_updated",
] as const;

export type PartnerColumnKey = (typeof PARTNER_COLUMN_ALLOWLIST)[number];

export const DEFAULT_VISIBLE_PARTNER_COLUMNS: PartnerColumnKey[] = [
  "partner_name",
  "partner_type",
  "region",
  "partner_tier",
  "support_level",
];

const COLUMN_LABEL_OVERRIDES: Record<string, string> = {
  partner_name: "Partner Name",
  partner_tier: "Partner Tier",
  status: "Status",
  partner_type: "Partner Type",
  account_manager: "Account Manager",
  partner_email: "Partner Email",
  website: "Website",
  country: "Country",
  region: "Region",
  revenue_stream: "Revenue Stream",
  partner_potential: "Partner Potential",
  partner_vertical: "Partner Vertical",
  registration_date: "Registration Date",
  support_level: "Support Level",
  last_updated: "Last Updated",
};

export const formatPartnerColumnLabel = (key: string): string => {
  if (COLUMN_LABEL_OVERRIDES[key]) return COLUMN_LABEL_OVERRIDES[key];
  return key
    .split("_")
    .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
    .join(" ");
};

export const getAvailablePartnerColumns = (): PartnerColumnKey[] => {
  return [...PARTNER_COLUMN_ALLOWLIST];
};

const ALLOWLIST_SET = new Set<string>(PARTNER_COLUMN_ALLOWLIST);

export const isPartnerColumnKey = (key: string): key is PartnerColumnKey => {
  return ALLOWLIST_SET.has(key);
};

export const getPartnerCellValue = (
  partner: PartnerDetailType,
  columnKey: string
): string => {
  const record = partner as unknown as Record<string, unknown>;

  const value = record[columnKey];

  if (value == null) return "";
  if (Array.isArray(value)) return value.join(", ");
  if (typeof value === "object") return "";
  return String(value);
};
